/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Select_Node_HintInputs */

const cs_workflow_select_node_hint = /** @type {(inputs: Workflow_Select_Node_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte uzel pro jeho konfiguraci`)
};

const en_workflow_select_node_hint = /** @type {(inputs: Workflow_Select_Node_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a node to configure it`)
};

/**
* | output |
* | --- |
* | "Select a node to configure it" |
*
* @param {Workflow_Select_Node_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_select_node_hint = /** @type {((inputs?: Workflow_Select_Node_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Select_Node_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_select_node_hint(inputs)
	return cs_workflow_select_node_hint(inputs)
});